import apiClient from './apiClient'

export default {
  login(usuario, password, dispositivoId) {
    return apiClient.post('Loginportal', {
      txtUsr: usuario,
      txtPwd: password,
      dispositivoId: dispositivoId
    })
  },

  logout(usuario, token) {
  return apiClient.post('Loginportal/logout', {
    usuario,
    token
  })
}
}